import { render, staticRenderFns } from "./ProfileStaticContent.vue?vue&type=template&id=e368e418&"
import script from "./ProfileStaticContent.vue?vue&type=script&lang=js&"
export * from "./ProfileStaticContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports